export default {
  categories: 'التصنيفات',
  category: 'التصنيف',
  add: 'إضافة تصنيف',
  update: 'تعديل التصنيف',
  details: 'تفاصيل التصنيف'
}
